export const API_ENDPOINTS = {
  // Auth
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/auth/logout',
  AUTH_REFRESH_TOKEN: '/auth/refresh-token',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
  AUTH_CHANGE_PASSWORD: '/users/change-password',
  AUTH_CHECK_USERNAME: '/auth/check-username',

  //Profile
  UPDATE_PROFILE: '/users/update-profile',

  //file upload
  UPLOAD_ASSETS: '/utility/s3-upload-urls',

  VERIFY_SIGNUP_OTP: '/auth/verify-signup-otp',
  AUTH_SIGNUP_RESEND_OTP: '/auth/resend-auth-otp',
  AUTH_RESEND_OTP: '/auth/resend-otp',
  AUTH_UPDATE_PROFILE: '/auth/update-profile-details',
  AUTH_RESET_PASSWORD: '/auth/reset-password',
  AUTH_VERIFY_OTP: '/auth/verify-otp',
  AUTH_USER_PROFILE: '/users/profile',

  //Configuration
  CONFIGURATION_LIST: '/configurations',

  //Dashboard
  DASHBOARD_DATA: '/dashborad',

  //Users information
  USERS_INFORMATION: '/users/me',

  //Admin Users
  ADMIN_USERS: '/admin-users',

  // Role
  ROLES: '/roles',

  // Service
  SERVICES: '/services',

  //Mountains
  MOUNTAINS_LIST: '/mountains',

  //Cars
  CARS_LIST: '/cars',

  // Hotel Commission Rates
  HOTEL_COMMISSION_RATES: '/hotel-commissions',
  HOTELS: '/hotels',

  // Instructors
  INSTRUCTORS: '/instructors',

  //Instructor Commission Rates
  INSTRUCTOR_COMMISSION_RATES: '/instructor-commissions',

  //Booking
  BOOKING_LIST: '/bookings',
  BOOKING_USERS_LIST: '/bookings/users',
  BOOKING_USERS_LIST_EXPORT: '/bookings/exports',
  BOOKING_BROADCAST_MANAGER: '/bookings/sendmail',

  //Daily Roster (Lesson Schedule)
  DAILY_ROSTER: '/schedule-lessons',
  DAILY_ROASTER_PROCESS_UNPROCESSED: '/schedule-lessons/process-and-unprocess',
  DAILY_ROASTER_UNDO_ROSTER: '/schedule-lessons/undo-roster',
  CHECK_CAR_AVAILABILITY: '/schedule-lessons/check-car-availability',
  CHECK_LESSON_AVAILABILITY: '/schedule-lessons/check-availablity',

  INSTRUCTOR_ROSTER_LESSON: '/schedule-lessons/instructor',

  PROCESSED_AGENT_COMMISSION: '/schedule-lessons/processed-agent-commission',
  PARTICIPANT: '/schedule-lessons/participant',
  PARTICIPANTS_LIST: '/schedule-lessons/participant/list',
  PARTICIPANT_UPDATE: '/schedule-lessons/edit-participant',

  LESSON_ENTRIES: '/schedule-lessons/entry',
  AGENT_COMMISSION: '/schedule-lessons/agent-commission',
  INSTRUCTOR_LIST: '/instructors/list-available-instructor',

  //Reports Manager
  INSTRUCTOR_REPORT: '/instructor-reports',
  INSTRUCTOR_REPORT_EXPORT: '/instructor-reports/export',

  FINANCIAL_REPORT: '/financial-reports',
  FINANCIAL_REPORT_SALARY_TOGGLE: '/financial-reports/salary-toggle',
  FINANCIAL_REPORT_EXPORT: '/financial-reports/exports',

  HOTEL_AGENTS_REPORT: '/hotel-agent-reports',
  HOTEL_AGENTS_REPORT_EXPORT: '/hotel-agent-reports/export',
  HOTEL_AGENTS_INVOICE_REPORT_EXPORT:
    '/hotel-agent-reports/get-invoice-commission-pdf',

  GROUP_LESSON_REPORT: '/groupLesson-reports',
  GROUP_LESSON_REPORT_EXPORT: '/groupLesson-reports/exports',

  MOUNTAIN_FINANCIAL_REPORT: '/mountain-reports',
  MOUNTAIN_FINANCIAL_REPORT_EXPORT: '/mountain-reports/exports',

  MOUNTAIN_FINANCIAL_REPORT_PARTICIPANTS: '/mountain-reports/participants',
  MOUNTAIN_FINANCIAL_REPORT_PARTICIPANTS_EXPORT:
    '/mountain-reports/participants/export',

  TRANSPORT_PAX_REPORTS: '/transport-pax-reports',
  TRANSPORT_PAX_REPORTS_EXPORT: '/transport-pax-reports/exports',

  //Transport Roster
  TRANSPORT_ROASTER: '/transport-roaster',

  //Cheat Sheet
  CHEAT_SHEET: '/cheat-sheets',
  CHEAT_SHEET_LUNCH_SHEET: '/cheat-sheets/kid-lunch-sheet',
  CHEAT_SHEET_EXPORT_LUNCH_SHEET: '/cheat-sheets/export-kid-lunch-sheet',

  //Diet Managers
  DIET_MANAGERS: '/diets',

  //Staff Managers
  STAFF_MANAGERS: '/staffs',
  STAFF_MANAGER_REPORT: '/staff-reports',
  STAFF_MANAGER_REPORT_EXPORT: '/staff-reports/exports',

  //Regions
  PREFECTURE: '/regions'
};
